<template>
    <div id="container" type="vdpp">
        <div class="page page-brokerage" v-ga:page="{pageType: glb.pageType, glb: glb}" v-ga:request="{pageType:'vbrokerage'}">
            <mvtHeader />
            <mvtWelcome>
                <template v-slot:img>
                    <img :src="brokerage.officeImage" :alt="brokerage.displayName" fetchpriority="auto">
                </template>
                <template v-slot:content>
                    <div>
                        <div><b class="f7">MOVOTO REAL ESTATE</b></div>
                        <h1 class="f0 text-bold">{{brokerage.displayName}} Office</h1>
                    </div>
                    <div v-if="brokerage.phone">
                        <div>Phone</div>
                        <div class="f4 text-bold"><a :href="'tel:' + brokerage.phone">{{$filters.formatPhoneNumber(brokerage.phone)}}</a></div>
                    </div>
                    <div v-if="brokerage.geo.address">
                        <div>Broker Address</div>
                        <div class="f4 text-bold">{{brokerage.geo.address}}</div>
                    </div>
                </template>
            </mvtWelcome>
            <brokerageAgent class="inline large"></brokerageAgent>
            <brokerageNearby class="inline large" :geo="glb.geo"></brokerageNearby>
            <brokerageBanner class="inline large bg-default" ></brokerageBanner>
            <agentRegion class="inline large"  :cities="brokerage.cities" :counties="brokerage.counties"/>
            <mvtFooter />
            <mvtDialogCenter></mvtDialogCenter>
        </div>
    </div>
</template>
<script src="./page-brokerage.js"></script>